import ledmodules, { getLedmodulesApiUrl, getLedmoduleApiUrl, putLedmoduleApiUrl, postLedmodulesApiUrl, importLedmoduleApiUrl, downloadLedmoduleApiUrl } from '../apis/ledmodules';
import auth, { postLoginApiUrl } from '../apis/auth';

import {
    SIGN_IN_RESET,
    SIGN_IN_OK,
    SIGN_IN_FAILURE,

    FETCH_LEDMODULES,
    FETCH_LEDMODULE,
    RESET_LEDMODULES,

    FETCH_ORIGINAL_LEDMODULE,
    
    CREATE_LEDMODULE,
    UPDATE_LEDMODULE,
    DELETE_LEDMODULE,
    RESET_LEDMODULE,

    FETCH_LEDMODULE_PROPERTIES,
    FETCH_LEDMODULE_FEATURES,

    DOWNLOAD_LEDMODULE,

    ERROR_ADD,
    ERROR_REMOVE,
    NOT_FOUND_ERROR_REMOVE,
    SET_TEMPORARY_LEDMODULE,

    ISSUES_ADD,

} from './types';

import { featuresWired, ORIGINAL_LEDMODULE_ID } from '../utils/constantFeatures';

/*
 *  AUTH
 */

export const signInReset = () => async dispatch => {
    dispatch({ type: SIGN_IN_RESET, payload: null });
}

export const signIn = () => async dispatch => {
    await auth.get(postLoginApiUrl())
        .then(response => {
            dispatch({ type: SIGN_IN_OK, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: SIGN_IN_FAILURE, payload: error.data });
        });
};

/*
 *  ISSUES
 */

export const addIssues = (issue) => async dispatch => {
    dispatch({ type: ISSUES_ADD, payload: issue });
}

/*
 *  LEDMODULES
 */

export const fetchLedmodules = () => async dispatch => {
    const response = await ledmodules.get(getLedmodulesApiUrl());
    dispatch({ type: FETCH_LEDMODULES, payload: response.data });
};

export const resetLedmodules = () => async dispatch => {
    dispatch({ type: RESET_LEDMODULES });
};

export const fetchOriginalLedmodule = () => async dispatch => {
    await ledmodules.get(getLedmoduleApiUrl(ORIGINAL_LEDMODULE_ID))
        .then(response => {
            dispatch({ type: FETCH_ORIGINAL_LEDMODULE, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const fetchLedmodule = (id) => async dispatch => {
    await ledmodules.get(getLedmoduleApiUrl(id))
        .then(response => {
            dispatch({ type: FETCH_LEDMODULE, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const fetchLedmoduleProperties = (id) => async dispatch => {
    await ledmodules.get(getLedmoduleApiUrl(id))
        .then(response => {
            dispatch({ type: FETCH_LEDMODULE_PROPERTIES, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const fetchLedmoduleFeatures = (type) => async dispatch => {
    const features = featuresWired(type);
    dispatch({ type: FETCH_LEDMODULE_FEATURES, payload: features });
};

export const createLedmodule = (ledmodule) => async dispatch => {
    await ledmodules.post(postLedmodulesApiUrl(), ledmodule)
        .then(ledmoduleId => {
            dispatch({ type: CREATE_LEDMODULE, payload: ledmoduleId.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const updateLedmodule = (id, ledmodule) => async dispatch => {
    await ledmodules.put(putLedmoduleApiUrl(id), ledmodule)
        .then(response => {
            dispatch({ type: UPDATE_LEDMODULE, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const resetLedmodule = () => async dispatch => {
    dispatch({ type: RESET_LEDMODULE });
};

export const deleteLedmodule = (id) => async dispatch => {
    await ledmodules.delete(getLedmoduleApiUrl(id))
        .then(response => {
            dispatch({ type: DELETE_LEDMODULE, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const downloadLedmodule = (id) => async dispatch => {
    await ledmodules.get(downloadLedmoduleApiUrl(id), { responseType: 'blob' })
        .then(response => {
            dispatch({ type: DOWNLOAD_LEDMODULE, payload: response });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: {'statusText': error.response.statusText} });
        });
};

export const importLedmodule = file => async dispatch => {
    const formData = new FormData();
    formData.append('moduleXml', file);
    await ledmodules.post(importLedmoduleApiUrl(), formData)
        .then(ledmoduleId => {
            dispatch({ type: CREATE_LEDMODULE, payload: ledmoduleId.data });
        })
        .catch(error => {
            dispatch({ type: ERROR_ADD, error: error.response });
        });
};

export const copyLedmodule = () => async dispatch => {
    //dispatch({ type: RESET_LEDMODULE });
};


/*
 *  EXTRA
 */
export const errorRemove = (error) => async dispatch => {
    dispatch({ type: ERROR_REMOVE, error: error });
};
export const notFoundErrorRemove = (error) => async dispatch => {
    dispatch({ type: NOT_FOUND_ERROR_REMOVE, error: error });
};

export const setTemporaryLedmodule = (isTemporary) => async dispatch => {
    dispatch({ type: SET_TEMPORARY_LEDMODULE, payload: isTemporary });
};
